/**
 * File: contactModal.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.1
 * Created: 2025-12-30
 * Last Updated: 2026-02-18
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Contact Modal
export const contactModal = {
    id: "contact-modal",
    formHeader: {
        header: "Start a Conversation",
        subheader: "Have a specific question? Our team is ready to assist.",
    },
    textField: {
        firstName: {
            label: "First Name",
        },
        lastName: {
            label: "Last Name",
        },
        message: {
            label: "Message",
        },
    },
    dropDownField: {
        label: "Subject",
        options: [
            {
                id: "contact-engnineering-services",
                value: "Engineering Services",
            },
            {
                id: "contact-software-products",
                value: "Software Products",
            },
            {
                id: "contact-customer-service",
                value: "Customer Service",
            },
            {
                id: "contact-careers",
                value: "Careers",
            },
        ],
    },
    textButton: {
        text: "Get in Touch",
        type: "primary",
    },
};
